var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M19.989 14.618l-4.947-2.216-.013-.007a1.679 1.679 0 00-1.593.147.847.847 0 00-.079.06l-2.555 2.178c-1.62-.786-3.291-2.445-4.078-4.044l2.182-2.594c.021-.026.041-.053.06-.081a1.68 1.68 0 00.139-1.581v-.013L6.882 1.512a1.68 1.68 0 00-1.745-1A5.907 5.907 0 000 6.38C0 14.717 6.783 21.5 15.12 21.5a5.907 5.907 0 005.868-5.137 1.68 1.68 0 00-.999-1.745zM15.12 19.82A13.455 13.455 0 011.68 6.38a4.221 4.221 0 013.661-4.2.065.065 0 000 .012l2.205 4.935-2.17 2.598a.643.643 0 00-.06.081 1.68 1.68 0 00-.105 1.649c.951 1.945 2.912 3.89 4.879 4.841a1.68 1.68 0 001.653-.12.87.87 0 00.078-.058l2.553-2.178 4.935 2.21h.011a4.222 4.222 0 01-4.2 3.67z"
  })));
}

export default SvgPhone;